import { Box } from "@chakra-ui/react";
import Hero from "../components/Landing/Hero";

function Landing() {
  return (
    <Box bg={"brand.100"}>
      <Hero />
    </Box>
  );
}

export default Landing;
